import { USERS } from '../constants';

const userReducer = (state = {}, action) => {
  switch (action.type) {
    case USERS.LOAD_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case USERS.LOAD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.users
      };
    case USERS.LOAD_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.error
      };
    default:
      return state;
  }
};

export default userReducer;



// WEBPACK FOOTER //
// ./src/reducers/userReducer.js